// extracted by mini-css-extract-plugin
export default {"fs":"f64790a3e9 _1a9c618345"};